import { createFileRoute } from '@tanstack/react-router';
import { StaffingPostingFormPage } from '@/pages/staffing/StaffingPostingFormPage';

export const Route = createFileRoute('/_authenticated/_app/staffing/postings/new')({
	component: () => <StaffingPostingFormPage />,
});
